import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { ScopeOverviewTab } from '../enum/scope-overview-tab.enum'
import { ScopePaginatedOverviewActions } from '../store/actions/scope-paginated-overview.actions'

export const SCOPE_TAB_PARAM = 'tab'

@Injectable({ providedIn: 'root' })
export class ScopeOverviewNavigationService {
  currentTab: string

  constructor(
    private store$: Store,
    private router: Router
  ) {}

  selectTab(tab: string) {
    this.currentTab = tab
    const tabParam = tab != ScopeOverviewTab.SCOPE ? tab.toLowerCase().split(' ')[0] : null
    this.router.navigate([], { queryParams: { [SCOPE_TAB_PARAM]: tabParam } })
  }

  selectTabAndReload(tab: string, scopeId: number) {
    this.selectTab(tab)
    this.store$.dispatch(ScopePaginatedOverviewActions.getCurrentScope({ scopeId }))
  }
}
